<template>
    <div id="app">
        <video src="./assets/video/bg.mp4" autoplay muted loop></video>
        <!-- <index /> -->
        <router-view></router-view>
    </div>
</template>

<script>
// import index from './page/index'
export default {
    name: 'App',
    components: {
        // index
    }
};
</script>

<style lang="scss">
#app {
    width: 1920px;
    height: 1080px;
    transform-origin: left top 0;
    video {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100% !important;
        height: 100%;
        z-index: -1;
    }
}
.dw {
    display: flex;
    justify-content: space-between;
}
.dw,
.bubbleCon {
    position: absolute;
    width: 90%;
    font-size: 14px;
    color: #ffffff;

    box-sizing: border-box;
    padding-right: 20px;
    top: 80px;
}
.bubbleCon {
    text-align: right;
}
</style>
